
/* injects from baggage-loader */

'use strict';

import CancelInvestmentModalController from './cancelinvestmentmodal.controller';
import CancelInvestmentModalTemplate from './cancelinvestmentmodal.html';

export default class CancelInvestmentModalComponent {
		constructor() {
				this.templateUrl = CancelInvestmentModalTemplate;
				this.controller = CancelInvestmentModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
